import gql from 'graphql-tag';

export default gql`
  query countFeedbackRating($productId: String!) {
    countFeedbackRating(productId: $productId) {
      data {
        rating
        count
      }
    }
  }
`;
